import React from 'react';
import AreaListView from './AreaList.view';
import { useAreaListState } from './AreaList.state';

interface IAreaListProps {
    vertical?: boolean;
    onSelection?: Function;
    isAreaGroupRestricted?: boolean;
}

export const AreaList: React.FC<IAreaListProps> = (props) => {
    const state = useAreaListState(props.vertical, props.onSelection, props.isAreaGroupRestricted);

    return (
        <AreaListView
            {...{
                ...state,
                ...{
                    vertical: props.vertical,
                    areas: state._areas,
                    areaGroups: state._areaGroups
                }
            }}
        ></AreaListView>
    );
};

export default AreaList;
